import { Dialog, Text } from "@flat-ui";
import { useProjectCreationContext } from "@pages/create-project/project-creation-context";
import { useAppNavigation } from "@router/use-app-navigation";

/**
 * Dialog to ask the user if they want to create a plan for the newly created project
 *
 * If so, they will be directed to the plan creation page for the project
 * Otherwise, they will be directed to the profile page of the member or company
 */
export function PlanCreationDialog(): React.JSX.Element {
  const projectCreationContext = useProjectCreationContext();

  const { navigateToPlanCreation, navigateToProfilePage } = useAppNavigation();

  const { subject, createdProjectId } = projectCreationContext;

  return (
    <Dialog
      open={true}
      title="Create plan for new project"
      onCancel={() =>
        navigateToProfilePage({
          subjectType: subject.type,
          subjectId: subject.company.id,
        })
      }
      confirmText="Yes"
      cancelText="No"
      onConfirm={() =>
        createdProjectId &&
        navigateToPlanCreation({
          subjectType: "PROJECT",
          subjectId: createdProjectId,
        })
      }
    >
      <Text variant="bodyL">
        Do you want to create a plan for this project now?
      </Text>
    </Dialog>
  );
}
